import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/5 bg-[#08080a] py-12 md:py-14"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <span className="relative w-14 h-14 flex items-center justify-center bg-[#f4ead7] border border-[var(--ps-gold)] shadow-[0_0_22px_rgba(197,168,128,0.35)]">
            <img
              src="https://customer-assets.emergentagent.com/job_theatre-tech-hub/artifacts/7ojvjvzb_p_edited.png"
              alt="Proscenio Solutions logo (P + S)"
              className="w-14 h-14 object-contain mix-blend-multiply"
            />
          </span>
          <div>
            <div className="font-serif-display text-lg text-white">
              Proscenio <span className="text-[var(--ps-brand-red)]">Solutions</span>
            </div>
            <div className="text-[11px] tracking-[0.24em] uppercase text-zinc-500 mt-1">
              {t.footer.tagline}
            </div>
          </div>
        </div>

        <div className="text-xs text-zinc-500 md:text-right">
          <div>
            © {year} Proscenio Solutions di Stefano Ongaro. {t.footer.rights}
          </div>
          <div className="mt-1">Piazza Mazzini 13 · Ro — Riva del Po (FE) · Italia</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
